import { hasValue } from "../../../utils/functions.js";
import dateField from "../../common/date-field";
import { AddMaskCnpjCpf } from "../../../utils/identity.js";
import decimalField from "../../common/decimal-field.vue";
import { analyticsMiddleware } from "vue-analytics";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";

export default {
  name: "accountspayable",
  components: {
    dateField,
    decimalField,
    VueTypeaheadBootstrap,
  },
  data: function () {
    return {
      countFilter: 1,
      filter: {
        initialCompetencyDate: null,
        finalCompetencyDate: null,
        initialIssueDate: null,
        finalIssueDate: null,
        initialDueDate: this.GetDate(true),
        finalDueDate: this.GetDate(false),
        Category: { Id: 0 },
        SupplierName: null,
        SupplierIdentity: null,
        payment: 0,
        initialValue: null,
        finalValue: null,
        conciliated: null,
        bankAccount: null
      },
      IsReturnProviderAdd: false,
      IsAccountsPayable: false,
      IdProviderNewAdd: 0,
      IsTicked: 0,
      infoPayable: {
        AccountsPayableTaxes: {
          PercentINSS: 11,
          PercentISSQN: 2,
          PercentIRRF: 1.5,
          PercentCSRF: 4.65,
          ValueINSS: 0,
          ValueISSQN: 0,
          ValueIRRF: 0,
          ValueCSRF: 0,
          TypeTaxes: 1,
          LiquidValue: 0,
          RawValue: 0,
          NumberInstallment: 1,
          Frequency: 1,
          InstallmentValueType: 1
        },
        Amount: null,
        AmountNet: 0,
        Category: {
          Id: 0,
        },
        CompetencyDate: null,
        Description: "",
        DueDate: null,
        Installment: 1,
        IssueDate: null,
        PaymentProvider: {
          AccountPayment: "",
          AgencyPayment: "",
          BankSlipNumber: "",
          CodeBankPayment: "",
          DigitAccountPayment: "",
          DigitAgencyPayment: "",
          IdBankPayment: 0,
          IdPaymentProviderInternalType: 0,
          NameBankPayment: "",
          Pix: ""
        },
        SupplierIdentity: '',
        SupplierName: '',
        TotalInstallment: 1,
        InstallMentValueType: 1,
        Frequency: 1,
        Id: 0,
        IdAccountsPayablePayment: 0,
        IdAccountsPayableTaxes: 0,
        isCancelProvider: false,
        addProviderIdentity: "",
        Conciliated: false,
        PaymentDate: null,
        BankAccount: null
      },
      listCategories: [],
      categorySearch: "",
      isSeeing: false,
      isSelected: false,
      isDisableRecurrence: false,
      loadingAddUpdate: false,
      loadingList: false,
      loadingModal: false,
      loadingReport: false,
      modalTitle: "Incluir Conta a Pagar",
      accountspayable: [],
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalAmount: 0,
        TotalItems: 0,
      },
      pOpened: null,
      validatedOutgoForm: false,
      filterValidationForm: false,
      selected: 1,
      options: [
        { text: 'O valor líquido referente a cada parcela', value: 1 },
        { text: 'O valor líquido a ser dividido pelo número de parcelas', value: 2 }
      ],
      providerIdentityOptions: [],
      providerNameOptions: [],
      enableNewProvider: true,
      controlSelect: true,
      objectPayment: [],
      cards: {
        amount: 0,
        amountNet: 0,
        amountPaid: 0,
        notConciliated: 0,
        amountShipping: 0
      },
      isCancelProvider: false,
      addProviderIdentity: "",
      rerenderIdentityForce: false,
      rerenderNameForce: false,
      pastTime: null,
      nowTime: null,
      updateFilterMinValue: true,
      updateFilterMaxValue: true,
      canSearchIdentity: true,
      canSearchName: true,
      listProviders: [],
      selectedProvider: null,
      providerSearch: "",
      listBankAccounts: [],
      bankAccountSearch: "",
      filterBankAccountSearch: "",
      filterCategorySearch: "",
    };
  },

  computed: {
    isDateRequired() {
      return this.infoPayable.ProviderInternal.Id;
    },
    filteredProviders() {
      if (!this.providerSearch) return this.listProviders;
      const q = this.providerSearch.toLowerCase();
      return this.listProviders.filter(
        (p) => p.CompanyName.toLowerCase().includes(q) || p.Identity.includes(q)
      );
    },
    bankAccountOptions() {
      return this.listBankAccounts.map(a => ({
        ...a,
        label: `${a.Bank.Code} - ${a.Bank.Name.trim()} - Ag ${a.BankAgency}${a.BankAgencyDigit ? '-' + a.BankAgencyDigit : ''} - Cc ${a.BankAccount}-${a.BankAccountDigit}`
      }));
    },
    categoryOptions() {
      return this.listCategories.map(c => ({ Id: c.Id, label: c.Name }));
    },
  },

  watch: {
    "pagination.PageNumber": function () {
      this.ListAccountsPayable();
    },
    "pagination.RowsPerPage": function () {
      this.ListAccountsPayable();
    },
    "infoOutgo.DueDate": function (nv) {
      if (!hasValue(this.infoOutgo.PaymentDate)) {
        this.infoOutgo.PaymentDate = nv;
      }
    },
    "filter.finalValue": function () {
      if (this.filter.finalValue < 0) {
        this.filter.finalValue = this.filter.finalValue * -1;
        this.updateFilterMaxValue = !this.updateFilterMaxValue;
        //bool para forçar o componente a atualizar
      }
    },
    "filter.initialValue": function () {
      if (this.filter.initialValue < 0) {
        this.filter.initialValue = this.filter.initialValue * -1;
        this.updateFilterMinValue = !this.updateFilterMinValue;
        //bool para forçar o componente a atualizar
      }
    }
  },

  beforeMount() {
    let params = this.$route.query;
    if (params != null && params.isCancelProvider) {
      this.isCancelProvider = true;
    }
    if (params != null && params.identity != undefined) {
      this.addProviderIdentity = params.identity;
    }
    if (params != null && params.IsReturnProviderAdd) {
      this.infoPayable = { ...JSON.parse(localStorage.getItem('infoPayable')) }
      this.IsReturnProviderAdd = params.IsReturnProviderAdd;
      this.IdProviderNewAdd = params.IdProvider;
      this.IsAccountsPayable = params.IsAccountsPayable;
      this.IsTicked = params.isTicket
    }
  },

  mounted() {
    this.ResetInfoPayable();
    this.ListAccountsPayable();
    this.ListPayableCategories();
    this.ListBankAccounts();
    if (this.isCancelProvider) {
      this.getAccountsPayableLocalStorage();
    }
    else if (this.addProviderIdentity != "") {
      this.getAccountsPayableLocalStorage();
      this.infoPayable.SupplierIdentity = this.addProviderIdentity;
      this.SearchIdentity();
    }
  },

  methods: {

    OnChangeValueFilter: function () {
      if (this.filter.finalValue != null && this.filter.initialValue != null) {
        if (this.filter.finalValue < this.filter.initialValue) {
          let aux = this.filter.finalValue;
          this.filter.finalValue = this.filter.initialValue;
          this.filter.initialValue = aux;
          this.updateFilterMaxValue = !this.updateFilterMaxValue;
          this.updateFilterMinValue = !this.updateFilterMinValue;
        }
      }
    },

    OpenProspect: function (e, isAccount) {
      this.saveAccountsPayableLocalStorage();
      e.preventDefault();
      this.$router.push({
        name: "providers",
        query: {
          IsAccountsPayable: isAccount,
        },
      });
    },

    saveAccountsPayableLocalStorage() {
      this.infoPayable.InstallmentValueType = this.selected;
      const parsed = JSON.stringify(this.infoPayable);
      localStorage.setItem('infoPayable', parsed);
      localStorage.setItem('isProviderSelected', this.isSelected);
    },

    getAccountsPayableLocalStorage: function () {
      this.OpenOutgo();
      this.infoPayable = { ...JSON.parse(localStorage.getItem('infoPayable')) }
      this.selected = this.infoPayable.InstallmentValueType;
      this.isSelected = false;
      this.$router.replace({ 'query': null });
    },

    CalculateTaxes: function () {
      if (this.infoPayable.Amount != null) {
        this.CalculateTaxesINSS();
        this.CalculateTaxesISSQN();
        this.CalculateTaxesIRRF();
        this.CalculateTaxesCSRF();
      } else {
        this.infoPayable.AccountsPayableTaxes.ValueINSS = 0;
        this.infoPayable.AccountsPayableTaxes.ValueISSQN = 0;
        this.infoPayable.AccountsPayableTaxes.ValueIRRF = 0;
        this.infoPayable.AccountsPayableTaxes.ValueCSRF = 0;
        this.infoPayable.AmountNet = 0;
      }
    },

    validateValue: function (value) {
      if (isNaN(value) || value == undefined || value == null)
        return false;
      else
        return true;
    },

    CalculateTaxesINSS: function () {
      let value = 0;
      if (this.infoPayable.Amount != null) {
        value = this.infoPayable.Amount;
      }

      if (this.validateValue(this.infoPayable.AccountsPayableTaxes.PercentINSS)) {
        this.$store
          .dispatch("CalculateTaxes", { Amount: value, Tax: this.infoPayable.AccountsPayableTaxes.PercentINSS })
          .then((response) => {
            this.infoPayable.AccountsPayableTaxes.ValueINSS = response;
          })
          .catch((error) => {
            this.$makeToast(undefined, "danger", "Erro ao calcular imposto", error);
          })
          .finally(() => {
            if (!this.isSeeing) {
              this.CalculateNetValue();
            }
          });
      }
    },

    CalculateTaxesISSQN: function () {
      let value = 0;
      if (this.infoPayable.Amount != null) {
        value = this.infoPayable.Amount;
      }

      if (this.validateValue(this.infoPayable.AccountsPayableTaxes.PercentISSQN)) {
        this.$store
          .dispatch("CalculateTaxes", { Amount: value, Tax: this.infoPayable.AccountsPayableTaxes.PercentISSQN })
          .then((response) => {
            this.infoPayable.AccountsPayableTaxes.ValueISSQN = response;
          })
          .catch((error) => {
            this.$makeToast(undefined, "danger", "Erro ao calcular imposto", error);
          })
          .finally(() => {
            if (!this.isSeeing) {
              this.CalculateNetValue();
            }
          });
      }
    },

    CalculateTaxesIRRF: function () {
      let value = 0;
      if (this.infoPayable.Amount != null) {
        value = this.infoPayable.Amount;
      }

      if (this.validateValue(this.infoPayable.AccountsPayableTaxes.PercentIRRF)) {
        this.$store
          .dispatch("CalculateTaxes", { Amount: value, Tax: this.infoPayable.AccountsPayableTaxes.PercentIRRF })
          .then((response) => {
            this.infoPayable.AccountsPayableTaxes.ValueIRRF = response;
          })
          .catch((error) => {
            this.$makeToast(undefined, "danger", "Erro ao calcular imposto", error);
          })
          .finally(() => {
            if (!this.isSeeing) {
              this.CalculateNetValue();
            }
          });
      }
    },

    CalculateTaxesCSRF: function () {
      let value = 0;
      if (this.infoPayable.Amount != null) {
        value = this.infoPayable.Amount;
      }

      if (this.validateValue(this.infoPayable.AccountsPayableTaxes.PercentCSRF)) {
        this.$store
          .dispatch("CalculateTaxes", { Amount: value, Tax: this.infoPayable.AccountsPayableTaxes.PercentCSRF })
          .then((response) => {
            this.infoPayable.AccountsPayableTaxes.ValueCSRF = response;
          })
          .catch((error) => {
            this.$makeToast(undefined, "danger", "Erro ao calcular imposto", error);
          })
          .finally(() => {
            if (!this.isSeeing) {
              this.CalculateNetValue();
            }
          });
      }
    },

    CalculateNetValue: function () {
      if (this.infoPayable.Amount != null) {
        this.infoPayable.AccountsPayableTaxes.Amount = this.infoPayable.Amount;
      } else {
        this.infoPayable.AccountsPayableTaxes.Amount = 0;
      }

      this.$store
        .dispatch("CalculateNetValue", this.infoPayable.AccountsPayableTaxes)
        .then((response) => {
          this.infoPayable.AmountNet = response;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao calcular valor líquido", error);
        })
        .finally(() => {
        });
    },

    OpenModalFilter: function () {
      this.filterValidationForm = false;
      this.$bvModal.show("mFilter");
    },

    Filter: function () {
      this.filterValidationForm = true;
      this.$refs.FilterValidationForm.validate().then((isValid) => {
        if (isValid) {
          this.$bvModal.hide("mFilter");
          this.ListAccountsPayable();
        }
      });
    },

    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = this.GetParamsData(false);
      this.$store
        .dispatch("ReportOutgo", { params: data })
        .then((response) => {
          if (response.UrlReport != null && response.UrlReport != undefined && response.UrlReport != "") {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast("Tente novamente mais tarde.", "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },

    ResetInfoPayable: function () {
      this.IsTicked = 0,
        this.infoPayable = {
          AccountsPayableTaxes: {
            PercentINSS: 11,
            PercentISSQN: 2,
            PercentIRRF: 1.5,
            PercentCSRF: 4.65,
            ValueINSS: 0,
            ValueISSQN: 0,
            ValueIRRF: 0,
            ValueCSRF: 0,
            TypeTaxes: 1,
            LiquidValue: 0,
            RawValue: 0,
            NumberInstallment: 1,
            Frequency: 1,
            InstallmentValueType: 1
          },
          Amount: null,
          AmountNet: 0,
          Category: {
            Id: 0
          },
          CompetencyDate: null,
          Description: "",
          DueDate: null,
          Installment: 1,
          IssueDate: null,
          PaymentProvider: {
            AccountPayment: "",
            AgencyPayment: "",
            BankSlipNumber: "",
            CodeBankPayment: "",
            DigitAccountPayment: "",
            DigitAgencyPayment: "",
            IdBankPayment: 0,
            IdPaymentProviderInternalType: 0,
            NameBankPayment: "",
            Pix: ""
          },
          SupplierIdentity: "",
          SupplierName: "",
          TotalInstallment: 1,
          Frequency: 1,
          InstallmentValueType: 1,
          Id: 0,
          IdAccountsPayablePayment: 0,
          IdAccountsPayableTaxes: 0,
          isCancelProvider: false,
          addProviderIdentity: "",
          Conciliated: false,
          PaymentDate: null,
          BankAccount: null
        };
    },

    AddUpdateAccountPayable: function () {
      this.validatedOutgoForm = true;
      this.infoPayable.InstallmentValueType = this.selected;
      let tempIdentity = this.infoPayable.SupplierIdentity.replaceAll(".", "").replace("/", "").replace("-", "");
      this.infoPayable.SupplierIdentity = tempIdentity;
      let tempPix = this.infoPayable.PaymentProvider.Pix.replaceAll(/[^a-zA-Z0-9]/g, "");
      this.infoPayable.PaymentProvider.Pix = tempPix;

      this.$refs.OutgoValidationForm.validate().then((isValid) => {
        if (isValid && this.infoPayable.Category.Id > 0) {
          this.isSeeing = true;
          if (this.pOpened == null) {
            // Add
            this.infoPayable.Amount = this.infoPayable.AccountsPayableTaxes.Amount;
            this.$store
              .dispatch("AddAccountPayable", this.infoPayable)
              .then(() => {
                this.$makeToast("A despesa foi cadastrada corretamente na base de dados", "success", "Despesa fixa");
                this.ListAccountsPayable();
                this.$bvModal.hide("mFormOutgo");
              })
              .catch((error) => {
                this.$makeToast(undefined, "danger", "Erro ao criar a despesa", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            if(this.infoPayable.TotalInstallment > 1)
            {
              this.isSeeing = false;
              this.$makeMsgBox(
                `Este lançamento possui outras parcelas, a alteração irá refletir somente na parcela atual, deseja alterar esta parcela?`,
                "Confirmar ALTERAÇÃO",
                this.saveChanges
              );
            } else {
              this.saveChanges();
            }
          }
        }
      });
    },

    saveChanges: function () {
      this.infoPayable.Amount = this.infoPayable.AccountsPayableTaxes.Amount;
      this.$store
        .dispatch("UpdateAccountPayable", this.infoPayable)
        .then(() => {
          this.$makeToast(
            "Suas modificações foram salvas na base de dados",
            "success",
            "Despesa fixa"
          );
          this.ListAccountsPayable();
          this.$bvModal.hide("mFormOutgo");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao atualizar a despesa",
            error
          );
        })
        .finally(() => {
          this.loadingAddUpdate = false;
          this.isSeeing = false;
        });
    },

    GetParamsData: function (deletePagination = false) {
      let data = {
        "filter.PageNumber": this.pagination.PageNumber,
        "filter.RowsPerPage": this.pagination.RowsPerPage,
        ...{
          "filter.Object.FilterInitialCompetencyDate": this.filter.initialCompetencyDate,
          "filter.Object.FilterFinalCompetencyDate": this.filter.finalCompetencyDate,
          "filter.Object.FilterInitialIssueDate": this.filter.initialIssueDate,
          "filter.Object.FilterFinalIssueDate": this.filter.finalIssueDate,
          "filter.Object.FilterInitialDueDate": this.filter.initialDueDate,
          "filter.Object.FilterFinalDueDate": this.filter.finalDueDate,
          "filter.Object.Category.Id": this.filter.Category.Id,
          "filter.Object.SupplierName": this.filter.SupplierName,
          "filter.Object.SupplierIdentity": this.filter.SupplierIdentity,
          "filter.Object.Payment": this.filter.payment,
          "filter.Object.InitialValue": this.filter.initialValue,
          "filter.Object.FinalValue": this.filter.finalValue,
          "filter.Object.Conciliated": this.filter.conciliated,
          "filter.Object.BankAccount.Id": this.filter.bankAccount && this.filter.bankAccount.Id ? this.filter.bankAccount.Id : null
        },
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.RowsPerPage;
        delete data.PageNumber;
      }
      return data;
    },

    ListPayableCategories: function () {
      this.$store
        .dispatch("ListAccountsPayableCategory", {})
        .then((response) => {
          this.listCategories = response.Objects;
          for (let i = 0; i < this.listCategories.length; i++) {
            if (this.listCategories[i].Id == 82) {
              this.listCategories.splice(i, 1);
              break;
            }
          }
        })
        .catch((error) => {
          this.$makeToast("Tente atualizar a página.", "danger", "Erro ao listar as credenciadoras", error);
        });
    },

    ListBankAccounts: function () {
      this.$store
        .dispatch("ListBankAccount", { params: { PageNumber: 1, RowsPerPage: 9999 } })
        .then((response) => {
          this.listBankAccounts = response.Objects;
        })
        .catch(() => {});
    },

    ListAccountsPayable: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.initialCompetencyDate)) this.countFilter++;
      if (hasValue(this.filter.finalCompetencyDate)) this.countFilter++;
      if (hasValue(this.filter.initialIssueDate)) this.countFilter++;
      if (hasValue(this.filter.finalIssueDate)) this.countFilter++;
      if (hasValue(this.filter.initialDueDate)) this.countFilter++;
      if (hasValue(this.filter.finalDueDate)) this.countFilter++;
      if (hasValue(this.filter.Category.Id)) this.countFilter++;
      if (hasValue(this.filter.SupplierName)) this.countFilter++;
      if (hasValue(this.filter.SupplierIdentity)) this.countFilter++;
      if (hasValue(this.filter.payment)) this.countFilter++;
      if (hasValue(this.filter.initialValue)) this.countFilter++;
      if (hasValue(this.filter.finalValue)) this.countFilter++;
      if (this.filter.conciliated !== null) this.countFilter++;
      if (this.filter.bankAccount && this.filter.bankAccount.Id) this.countFilter++;

      this.loadingList = true;
      let data = this.GetParamsData();

      delete data.TotalItems;
      delete data.TotalAmount;
      this.$store
        .dispatch("ListAccountsPayable", { params: data })
        .then((response) => {
          this.cards.amount = response.TotalAmount;
          this.cards = {
            amount: response.TotalAmount,
            amountNet: (response.TotalAmountNet != null) ? response.TotalAmountNet : 0,
            amountPaid: (response.TotalAmountPaid != null) ? response.TotalAmountPaid : 0,
            notConciliated: 88888.88,
            amountShipping: 88888.88
          }
          this.accountspayable = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
          this.pagination.TotalAmount = response.TotalAmount;
          this.pagination.filterInitialCompetencyDate = response.filterInitialCompetencyDate;
          this.pagination.filterFinalCompetencyDate = response.filterFinalCompetencyDate;
          this.pagination.filterInitialIssueDate = response.filterInitialIssueDate;
          this.pagination.filterFinalIssueDate = response.filterFinalIssueDate;
          this.pagination.filterInitialDueDate = response.filterInitialDueDate;
          this.pagination.filterFinalDueDate = response.filterFinalDueDate;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao listar as despesas", error);
        })
        .finally(() => (this.loadingList = false));
    },

    ResetFilter: function () {
      this.filter = {
        initialCompetencyDate: null,
        finalCompetencyDate: null,
        initialIssueDate: null,
        finalIssueDate: null,
        initialDueDate: this.GetDate(true),
        finalDueDate: this.GetDate(false),
        Category: { Id: 0 },
        SupplierName: null,
        SupplierIdentity: null,
        payment: 0,
        initialValue: null,
        finalValue: null,
        conciliated: null,
        bankAccount: null
      };
      this.filterBankAccountSearch = "";
      this.filterCategorySearch = "";
      this.ListAccountsPayable();
    },

    ViewAccountsPayable: function (e, i, edit) {
      e.preventDefault();
      let accountsPayable = { ...this.accountspayable[i] };

      let pix = ""
      if (accountsPayable.PaymentProvider.Pix != null) {
        if (accountsPayable.PaymentProvider.Pix.length <= 18) {
          accountsPayable.PaymentProvider.Pix = accountsPayable.PaymentProvider.Pix.replaceAll(/[^0-9]/g, "");
        }

        accountsPayable.PaymentProvider.Pix.length == 10
          ? (pix = accountsPayable.PaymentProvider.Pix.replace(/\D/g, '').replace(/^(\d{2})(\d{4})?(\d{4})?/, "($1) $2-$3"))
          : accountsPayable.PaymentProvider.Pix.length <= 14
            ? (pix = AddMaskCnpjCpf(accountsPayable.PaymentProvider.Pix))
            : pix = accountsPayable.PaymentProvider.Pix
      }
      accountsPayable.PaymentProvider.Pix = pix;

      this.selected = 1;
      this.validatedOutgoForm = false;
      this.loadingAddUpdate = false;
      this.ResetInfoPayable();
      this.pOpened = i;
      this.isDisableRecurrence = true;

      if (edit) {
        this.isSeeing = false;
        this.modalTitle = "Editar da despesa";
        this.isSelected = true;

      } else {
        this.isSeeing = true;
        this.modalTitle = "Detalhes da despesa";
      }
      this.infoPayable = { ...accountsPayable };
      this.categorySearch = (this.listCategories.find(c => c.Id === accountsPayable.Category.Id) || {}).Name || "";
      const ba = this.bankAccountOptions.find(a => a.Id === (accountsPayable.BankAccount && accountsPayable.BankAccount.Id));
      this.bankAccountSearch = ba ? ba.label : "";
      this.CalculateTaxes();
      this.$bvModal.show("mFormOutgo");
    },

    OpenOutgo: function (e) {
      if (e != undefined) {
        e.preventDefault();
      }
      this.validatedOutgoForm = false;
      this.loadingAddUpdate = false;
      this.ResetInfoPayable();
      this.pOpened = null;
      this.isSeeing = false;
      this.isDisableRecurrence = false;
      this.providerIdentityOptions = [];
      this.providerNameOptions = [];
      this.enableNewProvider = true;
      this.modalTitle = "Incluir Contas a Pagar";
      this.categorySearch = "";
      this.bankAccountSearch = "";
      this.EraseProviderSelected();
      this.$bvModal.show("mFormOutgo");
    },

    ConfirmDeleteAccountsPayable: function (e, i) {
      e.preventDefault();
      this.$makeMsgBox(
        `Você tem certeza que deseja remover essa conta a pagar?`,
        "Confirmar EXCLUSÃO",
        this.DeleteAccountsPayable,
        i
      );
    },

    DeleteAccountsPayable: function (i) {
      let deleted = this.accountspayable[i];
      this.$store
        .dispatch("DeleteAccountsPayable", { id: deleted.Id })
        .then(() => {
          this.$makeToast("A conta a pagar foi excluída com sucesso!", "success", "Contas a pagar");
          this.ListAccountsPayable();
          this.$bvModal.hide("mFormOutgo");
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao remover a conta a pagar", error);
        });
    },

    SearchProvider: function SearchByNameIdentity() {

      if ((this.infoPayable.SupplierName == null || this.infoPayable.SupplierName == "") && (this.infoPayable.SupplierIdentity == null || this.infoPayable.SupplierIdentity == "")) {
        this.$makeToast("o Nome ou CNPJ/CPF do fornecedor devem ser preenchidos para realizar a consulta. Verifique os campos e tente novamente!", "warning", "Contas a pagar");
      }
      else {
        this.$store
          .dispatch("GetProviderByNameIdentity", { name: this.infoPayable.SupplierName, identity: this.infoPayable.SupplierIdentity })
          .then((response) => {
            this.listProviders = response;

            if (this.listProviders && this.listProviders.length > 0)
              this.$bvModal.show("mProviders");
            else
              this.$makeToast("Nenhum fornecedor encontrado com os valores informados. Verifique os campos e tente novamente!", "warning", "Contas a pagar");
          })
          .catch((error) => {
            this.$makeToast(
              "Um erro ocorreu ao listar os fornecedores. Tente novamente.",
              "danger",
              "Erro ao listar os fornecedores",
              error
            );
          });
      }
    },

    ResetPaymentInfos: function () {
      this.infoPayable.PaymentProvider.IdPaymentProviderInternalType = 0;
      this.infoPayable.PaymentProvider.Pix = "";
      this.infoPayable.PaymentProvider.CodeBankPayment = "";
      this.infoPayable.PaymentProvider.IdBankPayment = 0;
      this.infoPayable.PaymentProvider.NameBankPayment = "";
      this.infoPayable.PaymentProvider.AgencyPayment = "";
      this.infoPayable.PaymentProvider.DigitAgencyPayment = "";
      this.infoPayable.PaymentProvider.AccountPayment = "";
      this.infoPayable.PaymentProvider.DigitAccountPayment = "";
      this.infoPayable.PaymentProvider.BankSlipNumber = "";
    },

    SetPaymentInfos: function (infos) {
      let pix = ""
      if (infos.PaymentProviderInternalPix != null) {
        infos.PaymentProviderInternalPix.Key.length == 10
          ? (pix = infos.PaymentProviderInternalPix.Key.replace(/\D/g, '').replace(/^(\d{2})(\d{4})?(\d{4})?/, "($1) $2-$3"))
          : infos.PaymentProviderInternalPix.Key.length <= 14
            ? (pix = AddMaskCnpjCpf(infos.PaymentProviderInternalPix.Key))
            : pix = infos.PaymentProviderInternalPix.Key
      }
      this.infoPayable.PaymentProvider.IdPaymentProviderInternalType = infos.PaymentProviderInternalType.Id;
      this.infoPayable.PaymentProvider.Pix = pix;
      this.infoPayable.PaymentProvider.CodeBankPayment = (infos.PaymentProviderInternalBank != null) ? infos.PaymentProviderInternalBank.Name.substring(0, 3) : "";
      this.infoPayable.PaymentProvider.IdBankPayment = (infos.PaymentProviderInternalBank != null) ? infos.PaymentProviderInternalBank.IdBank : 0;
      this.infoPayable.PaymentProvider.NameBankPayment = (infos.PaymentProviderInternalBank != null) ? infos.PaymentProviderInternalBank.Bank : "";
      this.infoPayable.PaymentProvider.AgencyPayment = (infos.PaymentProviderInternalBank != null) ? infos.PaymentProviderInternalBank.Agency : "";
      this.infoPayable.PaymentProvider.DigitAgencyPayment = (infos.PaymentProviderInternalBank != null) ? infos.PaymentProviderInternalBank.DigitAgency : "";
      this.infoPayable.PaymentProvider.AccountPayment = (infos.PaymentProviderInternalBank != null) ? infos.PaymentProviderInternalBank.Account : "";
      this.infoPayable.PaymentProvider.DigitAccountPayment = (infos.PaymentProviderInternalBank != null) ? infos.PaymentProviderInternalBank.DigitAccount : "";
    },

    GetDate: function (isInitial) {
      let today = new Date();
      if (isInitial) {
        return this.$options.filters.date(
          new Date(today.setDate(1)),
          "YYYY-MM-DD");
      } else {
        return this.$options.filters.date(
          new Date(today.getFullYear(), today.getMonth() + 1, 0),
          "YYYY-MM-DD");
      }
    },

    SetMinCompetencyFilter: function (date) {
      var dateFormat = new Date(date)
      return this.$options.filters.date(
        new Date(dateFormat.getFullYear(), dateFormat.getMonth() + 2),
        "YYYY-MM-DD");
    },

    CloseModalProviders: function () {
      this.$bvModal.hide("mProviders");
      this.providerSearch = "";
      this.selectedProvider = null;
    },

    SelectProvider: function (data) {
      this.$bvModal.hide("mProviders");
      this.providerSearch = "";
      const provider = Array.isArray(data) ? data[0] : data;
      this.infoPayable.SupplierName = provider.CompanyName;
      this.infoPayable.SupplierIdentity = provider.Identity;

      this.$store
        .dispatch("GetPaymentMethodProviderInternal", provider)
        .then((response) => {
          this.SetPaymentInfos(response.PaymentMethodProviderInternal);
          this.isSelected = true;
        })
        .catch((error) => {
          this.$makeToast(
            "Um erro ocorreu ao buscar os dados bancários do fornecedor selecionado. Tente novamente.",
            "danger",
            "Erro ao buscar dados bancários do fornecedor",
            error
          );
        });
    },

    EraseProviderSelected: function () {
      this.infoPayable.SupplierName = '';
      this.infoPayable.SupplierIdentity = '';
      this.ResetPaymentInfos();
      this.isSelected = false;
    },
  },
};


// WEBPACK FOOTER //
// ./src/components/pages/AccountsPayable/accountsPayable.js